import { Component } from '@angular/core';

import { EmptyStateComponent } from '@echospaces-web-monorepo/es-shared-ui';

/**
 * Coming-soon stub for the organization audit log. No backend yet —
 * lands when an event-sourced audit stream is wired up across the
 * member / island / upgrade flows.
 */
@Component({
  selector: 'es-admin-audit-log-page',
  imports: [EmptyStateComponent],
  template: `
    <div class="max-w-4xl mx-auto">
      <div class="mb-6">
        <h1 class="text-2xl font-bold font-exo">Audit log</h1>
        <p class="text-sm text-[var(--text-secondary)]">
          Who changed what, when — coming soon.
        </p>
      </div>
      <es-empty-state
        title="Audit log"
        description="A searchable history of organization-level changes (members, roles, upgrades, branding) will appear here once the event-sourced audit stream ships."
        icon="📜"
      ></es-empty-state>
    </div>
  `,
})
export class AdminAuditLogPageComponent {}
